import { Component, Input } from '@angular/core';


@Component({
    selector: 'app-img-round',
    templateUrl: './img-round.component.html',
    styleUrls: ['./img-round.component.scss']
})
export class ImgRoundComponent {

    @Input() src = 'assets/images/noimage.png';
    @Input() width = 64; // default
}
